import React, { useState, useEffect } from 'react';
import { userAppContext } from '../../context/Context';
import { ToAcademicForm, ToUpgradePlanForm } from './UpgradeTrialForm';
import AcademicApplicationService from '../../services/AcademicApplicationService';
import SharedButton from '@/global/Button/Button';

const STEP_ONE = 1;
const STEP_TWO = 2;
const STEP_THREE = 3;

const TrialExpired = () => {
  const { user } = userAppContext();
  const isAcademic = user['custom:application_role'] === 'ROLE_ACADEMIC';

  const [step, setStep] = useState(STEP_ONE);
  const [selectedStep, setSelectedStep] = useState(null);
  const [academicStatus, setAcademicStatus] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState(true);

  // Get academic status on mount
  useEffect(() => {
    const fetchAcademicStatus = async () => {
      if (user?.email) {
        try {
          const response = await AcademicApplicationService.getAcademicStatus(user.email);
          setAcademicStatus(response.status);
        } catch (error) {
          console.error('Error fetching academic status:', error);
        } finally {
          setLoadingStatus(false);
        }
      }
    };

    fetchAcademicStatus();
  }, [user?.email]);

  const goToStep = targetStep => setStep(targetStep);

  const handleSelection = plan => {
    setSelectedStep(plan);
    goToStep(STEP_TWO);
  };

  const renderStepContent = () => {
    switch (step) {
      case STEP_ONE:
        return (
          <div className="profile-selection">
            <h1 className="header-topic gradient-color">Your 7-Day Free Trial Has Ended</h1>

            {loadingStatus && (
              <div>
                <br />
                <h6>Loading your account status...</h6>
              </div>
            )}

            {!loadingStatus && academicStatus === 'pending' && (
              <div>
                <br />
                <h6>Your academic application is pending approval.</h6>
                <p>We will notify you once your application has been reviewed.</p>
              </div>
            )}

            {!loadingStatus && academicStatus === 'approved' && (
              <div>
                <br />
                <h6>Your academic application has been approved!</h6>
                <p>Complete your payment to activate your Academic plan.</p>
                <div className="cards-container">
                  <div className="card">
                    <h3>Pay for Academic Plan</h3>
                    <p>Complete your payment to get full access to DISGENET with your Academic license.</p>
                    <button
                      className="btn-gradient-pink"
                      onClick={() => handleSelection('Pay Academic Plan')}
                    >
                      Proceed to Payment
                    </button>
                  </div>
                </div>
              </div>
            )}

            {!loadingStatus && (academicStatus === null || academicStatus === 'active') && !isAcademic && (
              <div>
                <div className="cards-container">
                  <div className="card">
                    <h3>Apply for Free Academic Plan</h3>
                    <p>Are you a researcher or student? Apply for our free academic plan.</p>
                    <SharedButton
                      variant="gradient"
                      onClick={() => handleSelection('Request Academic Pricing')}
                    >
                      Apply for Academic
                    </SharedButton>
                  </div>
                  <div className="card">
                    <h3>Upgrade to Paid Plan</h3>
                    <p>
                      Want to keep using DISGENET? Click the button below to get more information about
                      available plans and pricing.
                    </p>
                    <SharedButton
                      variant="gradient"
                      onClick={() => handleSelection('Request Trial Pricing')}
                    >
                      Request Pricing
                    </SharedButton>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      case STEP_TWO:
        if (selectedStep === 'Request Academic Pricing') {
          return <ToAcademicForm onSubmit={() => goToStep(STEP_THREE)} />;
        } else if (selectedStep === 'Pay Academic Plan') {
          return (
            <div className="payment-info">
              <h3>Academic Plan Payment</h3>
              <p>Payment integration coming soon...</p>
              <SharedButton variant="secondary" onClick={() => goToStep(STEP_ONE)}>
                Back
              </SharedButton>
            </div>
          );
        } else {
          return <ToUpgradePlanForm onSubmit={() => goToStep(STEP_THREE)} />;
        }
      case STEP_THREE:
        return (
          <div className="final-step">
            <p>Your request has been successfully submitted.</p>
            <SharedButton variant="gradient" onClick={() => goToStep(STEP_ONE)}>
              Back to Start
            </SharedButton>
          </div>
        );
      default:
        return null;
    }
  };

  const renderBreadcrumbs = () => (
    <nav className="breadcrumbs">
      <span onClick={() => goToStep(STEP_ONE)} style={{ cursor: 'pointer' }}>
        Trial Expired
      </span>

      {step >= STEP_TWO && (
        <>
          {' '}
          &gt; <span>{selectedStep}</span>
        </>
      )}
      {step === STEP_THREE && <span style={{ cursor: 'pointer' }}> &gt; Confirmation</span>}
    </nav>
  );

  return (
    <div className="trial-expired-container">
      {renderBreadcrumbs()}
      <div className="steps-container">{renderStepContent()}</div>
    </div>
  );
};

export default TrialExpired;
